<template>
  <a v-if="type === 'list'" href="javascript:void(0);" @click="completeContract()">完成合同</a>
  <a-button v-else @click="completeContract()">完成合同</a-button>
</template>

<script lang="ts">
import { message, Modal } from "ant-design-vue";
import { PropType, computed, createVNode, defineComponent, reactive, toRefs } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { CompleteContractService } from "./service";
export default defineComponent({
  isGlobal: true,
  name: "CompleteContract",
  props: {
    type: {
      type: String,
      default: "list",
    },
    bizIdKey: {
      //对应id key值
      type: String,
      default: "id",
    },
    bizType: {
      type: String,
      required: true,
    },
    record: {
      type: Object as PropType<any>,
    },
  },
  emits: ["refresh"],
  setup(props, { emit }) {
    const state = reactive(<
      {
        approvalContent: string;
        loading: boolean;
        visible: boolean;
        currentUserId: string;
      }
    >{
      approvalContent: "",
      loading: false,
      visible: false,
    });
    const { run } = CompleteContractService.useCompleteContractChangeApi();
    const completeContract = () => {
      Modal.confirm({
        okText: "确认",
        cancelText: "取消",
        title: "请再次核算当前合同是否履约完成？",
        icon: createVNode(ExclamationCircleOutlined),
        content: createVNode("div", {}, [
          createVNode("span", { style: "color:red;" }, "此操作不可逆，请谨慎操作！"),
        ]),
        onOk: async () => {
          const res = await run(props.record[props.bizIdKey], props.bizType, "ywc");
          if (res.respCode === "0000") {
            emit("refresh");
          }
        },
      });
    };

    return {
      ...toRefs(state),
      completeContract,
    };
  },
});
</script>
<style scoped>
.flow-model-title {
  margin-bottom: 0;
  font-weight: 600;

  display: inline-block;
}
.flow-model__subtitle {
}
.mt14 {
  margin-top: -14px;
}
.flow-model-subtitle {
  font-size: 14px;
  padding-left: 10px;
}
</style>
